module.exports = __webpack_public_path__ + "img/Invasion-GBM_SPATA.8b5e5f91.png";